import React from 'react'
import { Selectbox } from 'view/components/options'
import { Field } from 'view/components/inputs'
import { Locale, Translation } from 'locale'
import { ValidationIssue } from 'api'
import { Decimal } from 'utils'

interface BaskedAllocationTimeSelectboxProps {
  value: number
  className?: string
  readOnly?: boolean
  disabled?: boolean
  onUpdate: (value: number) => void
  validationIssues?: ValidationIssue[]
  dataTestId?: string
}

export const BasketAllocationTimeSelectbox = React.forwardRef((props: BaskedAllocationTimeSelectboxProps, ref: React.Ref<Selectbox>) => {
  const { value, className, readOnly, disabled, validationIssues, onUpdate } = props

  const getDurationText = (duration: number) => {
    if (duration < 60) {
      return Locale.translate(Translation.SC_DURATION_MINUTES, { duration })
    }

    if (Decimal.mod(duration, 60) !== 0) {
      throw new Error('Duration above 1 hour needs to be at an increment of an hour')
    } else {
      return Locale.translate(Translation.SC_DURATION_HOURS, { duration: Decimal.divide(duration, 60) })
    }
  }

  return (
    <Selectbox
      ref={ref}
      className={className}
      optionKeys={[30, 60, 120, 180, 240, 300]}
      getOptionText={getDurationText}
      value={value}
      readOnly={readOnly}
      disabled={disabled}
      onUpdate={onUpdate as any}
      validationIssues={validationIssues ?? []}
    />
  )
})

export const BasketAllocationTimeSelectboxField = Field(BasketAllocationTimeSelectbox)
